<app-custom-stepper [linear]="false" (selectionChange)="changeStep($event)" [stepTitles]="stepNames">
    <cdk-step [completed]="selectedInstallments().length > 0" (interacted)="validateInstallments($event)">
        <ng-container *ngTemplateOutlet="installmentsStep"></ng-container>
    </cdk-step>
    <cdk-step [optional]="true">
        <ng-container *ngTemplateOutlet="detailsStep"></ng-container>
    </cdk-step>
    <cdk-step [optional]="true">
        <ng-container *ngTemplateOutlet="additionalsStep"></ng-container>
    </cdk-step>
    <cdk-step [optional]="true">
        <ng-container *ngTemplateOutlet="requirementsStep"></ng-container>
    </cdk-step>
    <cdk-step [optional]="true">
        <ng-container *ngTemplateOutlet="retentionStep"></ng-container>
    </cdk-step>
</app-custom-stepper>

<ng-template #installmentsStep>
    <div class="container-split">
        <!-- Listado de Cuotas -->
        <div class="scrollable-content">
            <div style="margin-bottom: 1rem;">
                <h5 style="font-weight: 700; color: #1e293b; margin-bottom: 0.25rem;">Seleccionar Cuotas</h5>
                <div class="helper-info">
                    <fa-icon [icon]="iconCalendar" style="color: #3b82f6;"></fa-icon>
                    <span>Seleccioná las cuotas mensuales que vas a cobrar hoy.</span>
                </div>
            </div>

            <div class="flex-column">
                <ng-container *ngFor="let insCheckbox of installments(); let ind = index">
                    <div class="installment-card" [class.selected]="installments()[ind].isSelected"
                        *ngIf="insCheckbox.installment.installmentStatusId != 1">

                        <div class="card-info">
                            <input type="checkbox" class="form-check-input custom-checkbox"
                                [checked]="installments()[ind].isSelected" (change)="updateInstallments(ind)">

                            <div class="flex-column">
                                <span class="card-title">{{ insCheckbox.installment.description | titlecase }}</span>
                                <span class="card-subtitle">Cuota ordinaria</span>
                            </div>
                        </div>

                        <div class="flex-row" style="align-items: center; gap: 1.5rem;">
                            <!-- Status Badge -->
                            <div>
                                <span class="badge-modern badge-pending"
                                    *ngIf="insCheckbox.installment.installmentStatusId == 4 && today <= insCheckbox.installment.expiryDate">
                                    Pendiente
                                </span>
                                <span class="badge-modern badge-partial"
                                    *ngIf="insCheckbox.installment.installmentStatusId == 3">
                                    Parcial
                                </span>
                                <span class="badge-modern badge-overdue"
                                    *ngIf="insCheckbox.installment.installmentStatusId == 2 || (insCheckbox.installment.installmentStatusId == 4 && today > insCheckbox.installment.expiryDate)">
                                    Vencido
                                </span>
                            </div>

                            <!-- Amount -->
                            <span class="card-amount">
                                {{ insCheckbox.installment.finalAmountToPay | currency:
                                (contract.contractCurrency === 2 ? 'USD' : 'ARS') : (contract.contractCurrency === 1 ?
                                'symbol-narrow' : 'symbol') : '1.0-0' }}
                            </span>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Resumen de Pago (Sidebar) -->
        <div class="summary-sidebar">
            <ng-container *ngTemplateOutlet="summary"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #detailsStep>
    <div class="container-split">
        <div class="scrollable-content" style="display: flex; flex-direction: column; align-items: center;">
            <div style="width: 100%; max-width: 500px; margin-bottom: 1.5rem;">
                <h5 style="font-weight: 700; color: #1e293b; margin-bottom: 0.25rem;">Datos del Pago</h5>
                <div class="helper-info">
                    <fa-icon [icon]="iconCalendar" style="color: #3b82f6;"></fa-icon>
                    <span>Definí el medio de pago, quién abona y la fecha de la operación.</span>
                </div>
            </div>

            <form class="flex-column" style="gap: 1.5rem; width: 100%; max-width: 500px;" [formGroup]="detailFormGroup">
                <!-- Payment Type Selection -->
                <div class="flex-column" style="gap: 0.75rem;">
                    <span
                        style="font-weight: 700; color: #475569; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.05em;">Medio
                        de Recepción</span>
                    <div class="custom-radio-group">
                        <label class="custom-radio-card"
                            [class.active]="detailFormGroup.get('paymentType').value === 2">
                            <input type="radio" name="paymentType" [value]="2" (change)="changePaymentType(2)"
                                formControlName="paymentType">
                            <fa-icon [icon]="iconSign" style="font-size: 1.25rem;"></fa-icon>
                            <span>Inmobiliaria</span>
                        </label>
                        <label class="custom-radio-card"
                            [class.active]="detailFormGroup.get('paymentType').value === 1">
                            <input type="radio" name="paymentType" [value]="1" (change)="changePaymentType(1)"
                                formControlName="paymentType">
                            <fa-icon [icon]="iconCalendar" style="font-size: 1.25rem;"></fa-icon>
                            <span>Terceros</span>
                        </label>
                    </div>
                </div>

                <div class="flex-row" style="gap: 1rem;">
                    <div class="flex-column" style="flex: 1; gap: 0.4rem;">
                        <span
                            style="font-weight: 700; color: #475569; font-size: 0.75rem; text-transform: uppercase;">Fecha</span>
                        <div class="input-group input-group-sm">
                            <input class="form-control" placeholder="AAAA-MM-DD" (ngModelChange)="formatDate($event)"
                                (click)="formatDate()" name="dp" formControlName="paymentDate" ngbDatepicker
                                #c="ngbDatepicker" [minDate]="{year: 1999, month: 11, day: 31}" readonly>
                            <button class="btn btn-outline-secondary" (click)="c.toggle()" type="button">
                                <fa-icon [icon]="iconCalendar"></fa-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="flex-column" style="gap: 0.4rem;">
                    <span
                        style="font-weight: 700; color: #475569; font-size: 0.75rem; text-transform: uppercase;">Inquilino
                        que abona</span>
                    <select class="form-select form-select-sm" formControlName="tenant">
                        <option [ngValue]="undefined" disabled>Seleccione un inquilino</option>
                        <option [ngValue]="tenant" *ngFor="let tenant of contract.tenants">
                            {{tenant.user.person.fullName}}</option>
                    </select>
                </div>

                <div class="flex-column" style="gap: 0.4rem;" *ngIf="detailFormGroup.value.paymentType == 1">
                    <span
                        style="font-weight: 700; color: #475569; font-size: 0.75rem; text-transform: uppercase;">Propietario
                        que recibe</span>
                    <select class="form-select form-select-sm" formControlName="owner">
                        <option [ngValue]="undefined" disabled>Seleccione un propietario</option>
                        <option [ngValue]="owner" *ngFor="let owner of contract.owners">
                            {{owner.user.person.fullName}}
                        </option>
                    </select>
                </div>
            </form>
        </div>
        <div class="summary-sidebar">
            <ng-container *ngTemplateOutlet="summary"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #additionalsStep>
    <div class="container-split">
        <div class="scrollable-content">
            <loading-spinner [liteMode]="true" [evaluation]="!isLoading">
                <div style="margin-bottom: 1rem;">
                    <h5 style="font-weight: 700; color: #1e293b; margin-bottom: 0.25rem;">Cargos Adicionales</h5>
                    <div class="helper-info">
                        <fa-icon [icon]="iconTrash" style="color: #3b82f6;"></fa-icon>
                        <span>¿Hay recargos o descuentos? Podés sumar punitorios o bonificaciones.</span>
                    </div>
                </div>

                <form class="flex-column" style="gap: 1.5rem;" [formGroup]="additionalChargesFormGroup">
                    <div class="flex-row"
                        style="justify-content: space-between; align-items: center; background: #f8fafc; padding: 1rem; border-radius: 10px;">
                        <span style="font-weight: 600; color: #1e293b;">¿Computar punitivos?</span>
                        <div class="btn-group">
                            <button type="button" class="btn btn-sm" [class.btn-primary]="payPunitives()"
                                [class.btn-outline-secondary]="!payPunitives()"
                                (click)="payPunitives.set(true)">Sí</button>
                            <button type="button" class="btn btn-sm" [class.btn-primary]="!payPunitives()"
                                [class.btn-outline-secondary]="payPunitives()"
                                (click)="payPunitives.set(false)">No</button>
                        </div>
                    </div>

                    <div class="flex-column" style="gap: 1rem;">
                        <h6 style="font-weight: 700; color: #475569; display: flex; align-items: center; gap: 0.5rem;">
                            Mes:
                            <select class="month-select" formControlName="monthId"
                                *ngIf="selectedInstallments().length != 1"
                                (ngModelChange)="installmentIdForAdditionalCharges.set($event)">
                                <option *ngFor="let ins of selectedInstallments();" [ngValue]="ins.id">{{ins.description
                                    | titlecase}}</option>
                            </select>
                            <span *ngIf="selectedInstallments().length == 1">{{ selectedInstallments()[0].description |
                                titlecase }}</span>
                        </h6>

                        <div class="flex-column"
                            style="background: white; border: 1px solid #e2e8f0; border-radius: 10px; min-height: 100px; padding: 1rem; gap: 0.5rem;">
                            <ng-container *ngFor="let ac of installmentForAdditionalCharges()?.additionalCharges">
                                <div class="flex-row"
                                    style="justify-content: space-between; align-items: center; padding: 0.5rem; border-bottom: 1px solid #f1f5f9;"
                                    *ngIf="!ac.punitive || payPunitives()">
                                    <span
                                        [ngStyle]="ac.sign ? {'color': '#10b981', 'font-weight': '600'} : {'color': '#ef4444', 'font-weight': '600'}">
                                        {{ ac.sign ? '+' : '-'}} {{ ac.amount | currency: (contract.contractCurrency ===
                                        2 ? 'USD' : 'ARS') : 'symbol-narrow' : '1.0-0' }}
                                    </span>
                                    <div class="flex-row" style="align-items: center; gap: 0.75rem;">
                                        <span style="color: #475569; font-size: 0.9rem;">{{ ac.detail }}<span *ngIf="ac.punitive" style="font-size: 85%; opacity: 0.7;"> (diario)</span></span>
                                        <fa-icon class="trash" style="color: #94a3b8;" [icon]="iconTrash"
                                            (click)="deleteAC(ac)" *ngIf="!ac.punitive"></fa-icon>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="flex-column"
                        style="gap: 1rem; padding: 1.5rem; background: #f8fafc; border-radius: 12px; border: 1px dashed #cbd5e1;">
                        <div class="flex-row" style="gap: 1rem;">
                            <select class="form-select month-select" style="flex: 1;" formControlName="sign">
                                <option [ngValue]="true">RECARGO (+)</option>
                                <option [ngValue]="false">DEDUCCIÓN (-)</option>
                            </select>
                            <input class="form-control" style="flex: 1;" type="number" formControlName="amount"
                                placeholder="Monto $">
                        </div>
                        <textarea class="form-control" rows="2" type="text" formControlName="detail"
                            placeholder="Razón del cargo..."></textarea>

                        <div class="flex-row" style="justify-content: flex-end; gap: 0.75rem;">
                            <button class="btn btn-light" type="button" (click)="resetCharges()">Limpiar</button>
                            <button class="btn btn-primary" style="background: #4f46e5;" type="button"
                                (click)="createCharges()">Agregar Cargo</button>
                        </div>
                    </div>
                </form>
            </loading-spinner>
        </div>
        <div class="summary-sidebar">
            <ng-container *ngTemplateOutlet="summary"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #requirementsStep>
    <div class="container-split">
        <div class="scrollable-content">
            <loading-spinner [liteMode]="true" [evaluation]="!isLoading">
                <div style="margin-bottom: 1rem;">
                    <h5 style="font-weight: 700; color: #1e293b; margin-bottom: 0.15rem;">Obligaciones e Impuestos</h5>
                    <div class="helper-info">
                        <fa-icon [icon]="iconCalendar" style="color: #3b82f6;"></fa-icon>
                        <span>Saldá servicios o impuestos. Hacé clic en un ítem para cargar su comprobante.</span>
                    </div>
                </div>

                <div class="step-internal-split">
                    <!-- Lista de Obligaciones (Izquierda) -->
                    <div class="internal-list">
                        <ng-container *ngFor="let row of requirements">
                            <div class="month-group" *ngIf="row.hasUnpaidRequirements">
                                <span style="font-weight: 700; color: #475569; font-size: 0.8rem;">{{
                                    row.month | titlecase }}</span>
                                <div class="flex-row" style="gap: 0.35rem; flex-wrap: wrap; margin-top: 0.25rem;">
                                    <span class="badge badge-modern hover-badge" *ngFor="let req of row.requirements"
                                        (click)="req.status == 'retenido' ? null : selectedRequirement.set({ data: row, req: req });"
                                        [ngClass]="{'text-bg-success': req.status == 'pago', 'text-bg-warning': req.status == 'parcial', 'text-bg-info': req.status == 'retenido',
                                        'text-bg-danger': req.status == 'vencido', 'text-bg-secondary': req.status == 'pendiente', 
                                        'selected-badge': selectedRequirement()?.req.id === req.id}">
                                        <fa-icon [icon]="iconService.getIcon(req.icon)"></fa-icon>
                                        {{ req.name }}
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <!-- Formulario de Edición (Derecha) -->
                    <div class="internal-form" *ngIf="selectedRequirement() !== null">
                        <form class="flex-column"
                            style="background: #f8fafc; border: 1px solid #4f46e5; border-radius: 12px; padding: 1rem; gap: 1rem;"
                            [formGroup]="requirementFormGroup">

                            <div class="flex-row" style="justify-content: space-between; align-items: center;">
                                <h6 style="font-weight: 700; margin: 0; color: #4f46e5; font-size: 0.85rem;">
                                    {{ selectedRequirement().req.name }}
                                </h6>
                                <button type="button" class="btn-close" style="scale: 0.7;"
                                    (click)="selectedRequirement.set(null)"></button>
                            </div>

                            <div class="flex-column" style="gap: 0.75rem;">
                                <div class="flex-row" style="gap: 0.5rem;">
                                    <div class="flex-column" style="flex: 1;">
                                        <label class="card-subtitle" style="font-size: 0.75rem;">Estado</label>
                                        <select class="form-select form-select-sm month-select" style="width: 100%;"
                                            formControlName="installmentStatusId">
                                            <option [value]="1">Saldar</option>
                                            <option [value]="3">Parcial</option>
                                        </select>
                                    </div>
                                    <div class="flex-column" style="flex: 1;">
                                        <label class="card-subtitle" style="font-size: 0.75rem;">Monto $</label>
                                        <input class="form-control form-control-sm" type="number"
                                            formControlName="amount" placeholder="0.00">
                                    </div>
                                </div>

                                <div class="flex-column" style="gap: 0.4rem;">
                                    <label class="card-subtitle" style="font-size: 0.75rem;">Detalle de
                                        operación</label>
                                    <input class="form-control form-control-sm" type="text" formControlName="details"
                                        placeholder="Ej: Transf. Nro 1234">
                                </div>

                                <div class="flex-row"
                                    style="justify-content: space-between; align-items: center; background: white; padding: 0.5rem; border-radius: 6px; border: 1px solid #e2e8f0;">
                                    <span style="font-weight: 600; font-size: 0.75rem;">¿Retener del pago?</span>
                                    <div class="btn-group">
                                        <button type="button" class="btn btn-xs btn-outline-info"
                                            [class.active]="isRetention()" (click)="isRetention.set(true)">Sí</button>
                                        <button type="button" class="btn btn-xs btn-outline-secondary"
                                            [class.active]="!isRetention()" (click)="isRetention.set(false)">No</button>
                                    </div>
                                </div>
                            </div>

                            <div class="flex-column" style="gap: 0.5rem; margin-top: 0.25rem;">
                                <button class="btn btn-sm btn-primary w-100" type="button"
                                    (click)="isRetention() ? addRetention() : addRequirementToPayment()">
                                    {{ isRetention() ? 'Confirmar Retención' : 'Cargar Pago' }}
                                </button>
                                <button
                                    *ngIf="selectedRequirement().req.status == 'pago' || selectedRequirement().req.status == 'parcial'"
                                    class="btn btn-sm btn-link text-danger p-0" style="font-size: 0.75rem;"
                                    type="button" (click)="deleteRequirementForPayment()">Eliminar carga</button>
                            </div>
                        </form>
                    </div>
                </div>
            </loading-spinner>
        </div>
        <div class="summary-sidebar">
            <ng-container *ngTemplateOutlet="summary"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #retentionStep>
    <div class="container-split">
        <div class="scrollable-content">
            <div style="margin-bottom: 1rem;">
                <h5 style="font-weight: 700; color: #1e293b; margin-bottom: 0.15rem;">Retenciones</h5>
                <div class="helper-info">
                    <fa-icon [icon]="iconTrash" style="color: #3b82f6;"></fa-icon>
                    <span>Revisá el listado de montos que se descuentan del pago total (retenciones).</span>
                </div>
            </div>

            <div class="flex-column" style="gap: 1.5rem;">
                <div class="table-responsive"
                    style="background: white; border-radius: 12px; border: 1px solid #e2e8f0; overflow: hidden;"
                    *ngIf="retainedRequirements().length > 0 || newRetentions().length > 0">
                    <table class="table table-hover" style="margin-bottom: 0;">
                        <thead class="table-light">
                            <tr>
                                <th>Mes</th>
                                <th>Concepto</th>
                                <th>Monto</th>
                                <th>Detalle</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let req of retainedRequirements()">
                                <td>{{ req.ins.month | titlecase }}</td>
                                <td>{{ req.req.name }}</td>
                                <td style="font-weight: 600; color: #1e293b;">{{ req.insReq.amount ? '$' : '' }}{{
                                    req.insReq.amount || '-' }}</td>
                                <td style="font-size: 0.85rem; color: #64748b;">{{ req.insReq.details || '-' }}</td>
                                <td class="text-end" style="padding-right: 1.5rem;">
                                    <fa-icon class="trash" style="color: #94a3b8;" [icon]="iconTrash"
                                        (click)="removeRetainedRequirement(req)"></fa-icon>
                                </td>
                            </tr>
                            <tr *ngFor="let ret of newRetentions()">
                                <td>-</td>
                                <td>Extra</td>
                                <td style="font-weight: 600; color: #1e293b;">{{ ret.amount | currency:
                                    (contract.contractCurrency === 2 ? 'USD' : 'ARS') : 'symbol-narrow' : '1.0-0' }}
                                </td>
                                <td style="font-size: 0.85rem; color: #64748b;">{{ ret.detail }}</td>
                                <td class="text-end" style="padding-right: 1.5rem;">
                                    <fa-icon class="trash" style="color: #94a3b8;" [icon]="iconTrash"
                                        (click)="deleteRetention(ret)"></fa-icon>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <form class="flex-column"
                    style="background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 12px; padding: 1.5rem; gap: 1rem;"
                    [formGroup]="retentionFormGroup">
                    <span style="font-weight: 700; color: #475569; font-size: 0.9rem;">Agregar retención extra</span>
                    <div class="flex-row" style="gap: 1rem;">
                        <input class="form-control" style="flex: 1;" type="number" formControlName="amount"
                            placeholder="Monto $">
                        <input class="form-control" style="flex: 2;" type="text" formControlName="detail"
                            placeholder="Razón de la retención...">
                        <button class="btn btn-primary" style="background: #4f46e5; min-width: 120px;" type="button"
                            (click)="createRetentions()">Agregar</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="summary-sidebar">
            <ng-container *ngTemplateOutlet="summary"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #summary>
    <div class="checkout-card">
        <h5 class="summary-title">Resumen de Pago</h5>

        <div class="flex-column" style="gap: 0.5rem; margin-bottom: 1.5rem;">
            <div class="summary-row">
                <span class="label">Método:</span>
                <span class="value">{{ detailFormGroup.value.paymentType == 1 ? 'Cuenta terceros' : 'Inmobiliaria'
                    }}</span>
            </div>
            <div class="summary-row" *ngIf="formattedPaymentDate">
                <span class="label">Fecha:</span>
                <span class="value">{{formattedPaymentDate | date: 'shortDate'}}</span>
            </div>
            <div class="summary-row">
                <span class="label">Abonante:</span>
                <span class="value">{{detailFormGroup.value.tenant?.user.person.fullName || '-' }}</span>
            </div>
        </div>

        <div class="flex-column" style="gap: 0.75rem;">
            <div class="summary-row" *ngIf="contract?.tenantAmountInFavor">
                <span class="label">Saldo a Favor:</span>
                <span class="value text-success">-{{contract?.tenantAmountInFavor | currency: (contract.contractCurrency
                    === 2 ? 'USD' : 'ARS') : 'symbol-narrow' : '1.0-0'}}</span>
            </div>
            <div class="summary-row">
                <span class="label">Subtotal Cuotas:</span>
                <span class="value">{{installmentAmount() || 0 | currency: (contract.contractCurrency === 2 ? 'USD' :
                    'ARS') : 'symbol-narrow' : '1.0-0'}}</span>
            </div>
            <div class="summary-row" *ngIf="additionalChargesAmount()">
                <span class="label">Adicionales:</span>
                <span class="value">{{additionalChargesAmount() | currency: (contract.contractCurrency === 2 ? 'USD' :
                    'ARS') : 'symbol-narrow' : '1.0-0'}}</span>
            </div>
            <div class="summary-row" *ngIf="punitiveAmount()">
                <span class="label">Punitivos (diario):</span>
                <span class="value text-danger">{{punitiveAmount() | currency: (contract.contractCurrency === 2 ? 'USD'
                    : 'ARS') : 'symbol-narrow' : '1.0-0'}}</span>
            </div>
            <div class="summary-row" *ngIf="retentionAmount()">
                <span class="label">Retenido:</span>
                <span class="value text-info">-{{retentionAmount() | currency: (contract.contractCurrency === 2 ? 'USD'
                    : 'ARS') : 'symbol-narrow' : '1.0-0'}}</span>
            </div>
        </div>

        <div class="total-row">
            <span class="total-label">TOTAL</span>
            <span class="total-amount">{{totalAmount() || 0 | currency: (contract.contractCurrency === 2 ? 'USD' :
                'ARS') : 'symbol-narrow' : '1.0-0'}}</span>
        </div>
    </div>

    <!-- Payment Actions -->
    <div class="sidebar-actions">
        <div class="flex-column" *ngIf="selectedInstallments().length === 1">
            <label class="card-subtitle" style="margin-bottom: 0.15rem;">Descripción (opcional)</label>
            <input class="form-control form-control-sm" type="text" placeholder="Ej: Pago parcial..."
                [ngModel]="paymentDescription()" (ngModelChange)="paymentDescription.set($event)">
        </div>

        <div class="flex-column">
            <label class="card-subtitle" style="margin-bottom: 0.15rem;">Monto a abonar</label>
            <input class="form-control" type="number"
                style="font-size: 1.15rem; font-weight: 700; color: #4f46e5; padding: 0.4rem;"
                [ngModel]="paymentAmount()" (ngModelChange)="validatePayment($event)" appLimitDirective>
        </div>

        <button class="btn-pay" (click)="pay()" [disabled]="!(selectedInstallments().length > 0) || isLoading">
            <ng-container *ngIf="!isLoading">
                <fa-icon [icon]="iconSign"></fa-icon>
                Confirmar Pago
            </ng-container>
            <ng-container *ngIf="isLoading">
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Procesando...</span>
                </div>
                Procesando...
            </ng-container>
        </button>
    </div>
</ng-template>